import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

import logoSvant from "./img/svant-logo.svg";

const Login = () => {
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/dashboard";

  const handleLogin = (e) => {
    e.preventDefault();
    if (login(password)) {
      navigate(from, { replace: true });
    } else {
      alert("Contraseña incorrecta");
    }
  };

  return (
    <div className="container">
      <img
        className='logoSvant'
        src={logoSvant}
        alt="Svant Measure and Act"
      />

      <h2>Acceso restringido al equipo de Svant.</h2>

      <form onSubmit={handleLogin}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Contraseña"
        />
        <button type="submit">Entrar</button>
      </form>
    </div>
  );
};

export default Login;
